// extracted by mini-css-extract-plugin
export var buttonArticles = "Post-module--buttonArticles--d793a";
export var buttons = "Post-module--buttons--2972d";
export var comments = "Post-module--comments--d3b99";
export var content = "Post-module--content--3c6e5";
export var footer = "Post-module--footer--f8705";
export var post = "Post-module--post--3a994";